export const VariationIds = {
  Cpc_AB_Test: "201",
  ExpandedDescription_AB_Test: "202",
  Quantity_Discount_AB_Test: "203",
  WordRemovalSearchModel_AB_Test: "403",
  SearchStrategy_AB_Test: "401",
};
